var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.4 190",
    style: {
      enableBackground: "new 0 0 217.4 190"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8247E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.5,59c-3.9-2.3-9-2.3-13.3,0l-30.5,18L97.9,88.7l-30.5,18c-3.9,2.3-9,2.3-13.3,0L29.9,92.6 c-3.9-2.3-6.7-6.7-6.7-11.3V53.5c0-4.7,2.3-9,6.7-11.3l23.9-13.7c3.9-2.3,9-2.3,13.3,0l23.9,13.7c3.9,2.3,6.7,6.7,6.7,11.3v18 l20.7-12.1v-18c0-4.7-2.3-9-6.7-11.3L67.4,4.2c-3.9-2.3-9-2.3-13.3,0L9.1,30c-4.3,2.3-6.7,6.7-6.7,11.3v52c0,4.7,2.3,9,6.7,11.3 l45,25.8c3.9,2.3,9,2.3,13.3,0l30.5-17.6l20.7-12.1l30.5-17.6c3.9-2.3,9-2.3,13.3,0l23.9,13.7c3.9,2.3,6.7,6.7,6.7,11.3V136 c0,4.7-2.3,9-6.7,11.3l-23.9,14.1c-3.9,2.3-9,2.3-13.3,0l-23.9-13.7c-3.9-2.3-6.7-6.7-6.7-11.3v-18l-20.7,12.1v18 c0,4.7,2.3,9,6.7,11.3l45,25.8c3.9,2.3,9,2.3,13.3,0l45-25.8c3.9-2.3,6.7-6.7,6.7-11.3v-52c0-4.7-2.3-9-6.7-11.3L162.5,59z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon_icon.fa55dfb4be078c7fad665e67a5326333.svg";
export { ForwardRef as ReactComponent };